import { ClientConfigSlice } from '@framework/auth/client-config/ClientConfigSlice.tsx';
import {
  AuthSlice,
  logoutListnerMiddleware,
} from '@framework/auth/state/AuthSlice.tsx';
import { configureStore } from '@reduxjs/toolkit';

export const store = configureStore({
  reducer: {
    auth: AuthSlice.reducer,
    clientConfig: ClientConfigSlice.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().prepend(logoutListnerMiddleware.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
